<template>
  <div class="" data-testid="financialclose_component_checklist_bulkupload__root">
  <v-btn color="secondaryBtn" class="mr-1 px-4 py-1 "  @click="uploaddata = []; file = null; dialog = true" data-testid="financialclose_component_checklist_bulkupload__open-drawer-btn">
      <v-icon class="pr-2">mdi-file-document-plus-outline</v-icon>
      <span class="">Bulk Upload</span>
    </v-btn>
    <lb-drawer :Maxwidth="(uploaddata.length > 0) ? '1665' : '700'" v-model="dialog" 
      heading="Bulk Upload" :loading="loading" data-testid="financialclose_component_checklist_bulkupload__drawer">
      <template v-slot:body>
  <div data-testid="financialclose_component_checklist_bulkupload__drawer-body">
          <div class="d-flex align-center justify-space-between " data-testid="financialclose_component_checklist_bulkupload__drawer-header">
            <span class="text-center mb-1" v-if="uploaddata.length === 0" data-testid="financialclose_component_checklist_bulkupload__upload-prompt">Upload your document</span>
            <span v-else data-testid="financialclose_component_checklist_bulkupload__preview-label">Preview</span>

            <div class="d-flex" data-testid="financialclose_component_checklist_bulkupload__drawer-header-btns">
              <v-btn text v-if="uploaddata.length>0" @click="uploaddata=[],showdatawitherror=false,dataerror=[],flag=false" data-testid="financialclose_component_checklist_bulkupload__reupload-btn"> <v-icon>mdi-reload</v-icon> <span>Re-Upload</span> </v-btn>
              <v-btn  class="secondaryBtn d-flex align-center mb-2"
                @click="downloadTemplate()" data-testid="financialclose_component_checklist_bulkupload__download-template-btn"><span>Download Template</span></v-btn>
            </div>
          </div>
          <div class="d-flex align-center justify-space-between " v-if="uploaddata.length > 0" data-testid="financialclose_component_checklist_bulkupload__show-errors-checkbox-row">
            <v-checkbox color="caccounting" v-model="showdatawitherror" data-testid="financialclose_component_checklist_bulkupload__show-errors-checkbox"> <template v-slot:label>
                <span>Show only items with errors</span>
              </template> </v-checkbox>
            <v-spacer></v-spacer>
          </div>
        </div>
          <div class="d-flex align-center justify-center" data-testid="financialclose_component_checklist_bulkupload__dragdrop-panel">
            <DragDropfile v-if="uploaddata.length === 0" hidedetails :files="file" @update:files="updateFilesBulk" data-testid="financialclose_component_checklist_bulkupload__dragdrop-component"  />
        </div>   
        <div v-if="uploaddata.length > 0" class="radius-small border-on simple-table " style="max-height:73vh; overflow:scroll" data-testid="financialclose_component_checklist_bulkupload__table-panel">
          <v-simple-table data-testid="financialclose_component_checklist_bulkupload__table">
            <template v-slot:default>
              <thead class="tableHeaderBg" data-testid="financialclose_component_checklist_bulkupload__table-header">
                <th class="text-center tableHeaderBg" scope="sno" data-testid="financialclose_component_checklist_bulkupload__table-header-col-sno">S No.</th>
                <th class="text-center tableHeaderBg" scope="description" data-testid="financialclose_component_checklist_bulkupload__table-header-col-description">Description</th>
                <th class="text-center tableHeaderBg" scope="category" data-testid="financialclose_component_checklist_bulkupload__table-header-col-category">Category</th>
                <th class="text-center tableHeaderBg" scope="subcategory" data-testid="financialclose_component_checklist_bulkupload__table-header-col-subcategory">Sub Category</th>
                <th class="text-center tableHeaderBg" scope="location" data-testid="financialclose_component_checklist_bulkupload__table-header-col-location">Location</th>
                <th class="text-center tableHeaderBg" scope="assertions" data-testid="financialclose_component_checklist_bulkupload__table-header-col-assertions">Assertions</th>
                <th class="text-center tableHeaderBg" scope="purpose" data-testid="financialclose_component_checklist_bulkupload__table-header-col-purpose">Purpose</th>
                <th class="text-center tableHeaderBg" scope="instructionHe" data-testid="financialclose_component_checklist_bulkupload__table-header-col-instructionHe">Instruction</th>
                <th class="text-center tableHeaderBg" scope="preparer" data-testid="financialclose_component_checklist_bulkupload__table-header-col-preparer">Preparer</th>
                <th class="text-center tableHeaderBg" scope="approver" data-testid="financialclose_component_checklist_bulkupload__table-header-col-approver">Approver</th>
                <th v-if="!project" class="text-center tableHeaderBg" scope="tags" data-testid="financialclose_component_checklist_bulkupload__table-header-col-tags">Tags</th>
                <th class="text-center tableHeaderBg" scope="duedays" data-testid="financialclose_component_checklist_bulkupload__table-header-col-duedays">Due days</th>
                <th class="text-center tableHeaderBg" scope="glcode" data-testid="financialclose_component_checklist_bulkupload__table-header-col-glcode">Account No.</th>
              </thead>
              <v-slide-y-transition group tag="tbody" style="overflow:hidden !important;">
                <tr
                v-for="(row, index) in filteredData"
                :key="index"
                :data-testid="`financialclose_component_checklist_bulkupload__table-row-${index}`"
                >
                <td data-testid="financialclose_component_checklist_bulkupload__table-row-serial">{{ index + 1 }}</td>
                <template v-for="(cell, key) in row">
                    <td v-if="errorsonly[index][key]" :key="key" class="font-size-xm pa-0  border-right-data" :data-testid="`financialclose_component_checklist_bulkupload__table-cell-${key}-error`" >
                      <div class="all-width all-height" style="border: 1px solid #F3B9BA">
                        <v-tooltip bottom content-class="tooltip-bottom">
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              v-if="key === 'assertions' || key === 'location'"
                              class="d-inline-block"
                            >
                              <v-chip
                                v-for="(error, errorKey) in cell"
                                :key="errorKey"
                                label
                                v-bind="attrs"
                                v-on="on"
                                color="error"
                               
                                outlined
                                class="pl-2 mb-1 mr-1"
                                :data-testid="`financialclose_component_checklist_bulkupload__chip-error-${errorKey}`"
                              >
                                <span class="pl-1">{{ error }}</span>
                              </v-chip>
                            </div>
                            <span v-else v-bind="attrs" v-on="on">
                              {{ errorsonly[index][key] }}
                            </span>
                          </template>
                        </v-tooltip>
                      </div>
                    </td>
                    <td v-else :key="key" :data-testid="`financialclose_component_checklist_bulkupload__table-cell-${key}`">
                      <div v-if="(key === 'tags' || key === 'location') && cell && cell.length > 0" class="d-flex align-center">
                        <v-chip label outlined class="lightpurple caccounting--text pl-2 mb-1 mr-1" data-testid="financialclose_component_checklist_bulkupload__chip-main">
                          <span class="pl-1">{{ cell[0] }}</span>
                        </v-chip>
                        <span v-if="cell.length > 1" class="border-on px-1 radius-small font-size-xs font-weight-medium" data-testid="financialclose_component_checklist_bulkupload__chip-more">+{{ cell.length - 1 }}</span>
                      </div>
                      <div v-else-if="key === 'approver' || key === 'preparer'">
                        <v-avatar v-for="(va, ka) in cell" :key="ka" size="28" class="primary white--text mb-1 mr-1" :data-testid="`financialclose_component_checklist_bulkupload__avatar-${key}-${ka}`">
                          <v-tooltip top content-class="tooltip-top">
                            <template v-slot:activator="{ on, attrs }">
                              <span v-bind="attrs" v-on="on" class="text-uppercase font-weight-medium">{{ va[0] }}</span>
                            </template>
                            <span>{{ va }}</span>
                          </v-tooltip>
                        </v-avatar>
                      </div>
                      <div v-else-if="key === 'assertions'" class="d-flex align-center">
                        <span v-if="cell?.length >= 1" data-testid="financialclose_component_checklist_bulkupload__assertion-main">
                          {{ cell[0] }}
                        </span>
                        <span v-if="cell.length > 1" class="border-on px-1 ml-1 radius-small font-size-xs font-weight-medium" data-testid="financialclose_component_checklist_bulkupload__assertion-more">+{{ cell.length - 1 }}</span>
                      </div>
                      <div v-else-if=" key === 'glcode'">
                        <div v-for="(va, ka) in cell" :key="ka" outlined class="pl-2 mb-1 mr-1" :data-testid="`financialclose_component_checklist_bulkupload__glcode-chip-${ka}`">
                            <span class="pl-1">{{ va}}</span>
                        </div>
                      </div>
                      <div v-else class="two-line-clamp">{{ cell }}</div>
                    </td>
                  </template>
                </tr>
              </v-slide-y-transition>
            </template>
          </v-simple-table>
          
        </div>
  <p v-if="flag" class="error--text ma-0 pa-0 mt-4 font-size-xm" data-testid="financialclose_component_checklist_bulkupload__error-msg">*These are fields where errors exist / information missing. Please rectify and re-upload to continue. (Preparer & Approver cannot be the same user)</p>
      </template>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <div v-if="uploaddata.length > 0">
       <v-btn class="ml-2 white--text" color="primary" v-if="!flag" @click="uploadData()" data-testid="financialclose_component_checklist_bulkupload__upload-btn"><span>Upload</span></v-btn>
          <v-btn class=""  @click="cleardata()" data-testid="financialclose_component_checklist_bulkupload__cancel-btn"><span>Cancel</span>
          </v-btn>
        </div>
      </template>
    </lb-drawer>
  </div>
</template>

<script>
import DragDropfile from '../../../../views/Inputs/DragDropfile.vue';
import { CHECKLIST_VALIDATION_MESSAGES } from '../../utils/bulkUploadValidationMessages';

export default {
  name: 'financialclose_component_checklist_bulkupload',
  // props: ['props'],
  data: function () {
    return {
      right: "financialclose_master_checklist",
      // generateddescription: "",
      file: null,
      fileprocessing: {},
      flag: false,
      uploaddata: [],
      dataerror: [],
      dialog: false,
      loading: false,
      showdatawitherror:false,
      errorsonly:[]
    }
  },
  created() {
    this.dataerror=[]
  },
  activated() {
  },
  props: {
    project: {
      type: String,
    },
  },
  components:{
    DragDropfile
  },
  methods: {
   
    init() {
    },
    downloadTemplate(){
      if(this.project) this.$nova.downloadFile('', {}, '/v2/financialclose/analysis/getbulkchecklisttemplate');
      else this.$nova.downloadFile('', {}, '/v2/financialclose/masters/checklist/getbulksubmittemplate');
    },
    cleardata(){
      this.file =  null;
      this.fileprocessing =  {};
      this.flag =  false;
      this.uploaddata =  [];
      this.dataerror =  [];
      this.dialog =  false;
      this.loading =  false;
      this.showdatawitherror = false;
    },
    readFile(key) {
      let file = this.file;
      if ((file || {}).name && (this.fileprocessing[key] || 0) === 0) {
        let headings = ['Description', 'Category', 'Sub Category','Location', 'Assertions', 'Purpose', 'Instruction', 'Preparer', 'Approver', 'Tags', 'Due Days', 'Account No'];
        // let possibleassertions = ['Existence', 'Occurrence', 'Rights and obligations', 'Completeness', 'Accuracy valuation and allocation', 'Cut–off', 'Classification', 'Presentation'];
        this.loading = true;
        this.fileprocessing[key] = 1;
        let ext = ((file || {}).name || "").split(".").pop();
        Promise.resolve().then(() => {
          if (["xlsx", "xls", "xlsm", "xlsb"].indexOf(ext) === -1) throw new "Only xlsx,xls,xlsm,xlsb file extension supported";
          return this.$nova.readExcelFile(file, "TOP SHEET");
        }).then(async (dt) => {
          if (JSON.stringify(dt[0] || []) === JSON.stringify(headings)) {
            let filedata = [];
            let errordata = [];
            let chartofaccountData = [];
            this.flag = false;
            await this.axios.post("/v2/financialclose/masters/chartofaccount/get")
              .then((dt) => {
                if (dt.data.status === "success") {
                  chartofaccountData.push({ "data": dt.data.data })
                }
              });
            // Pre-compute COA category/subcategory lists for AC task validation
            const coaCategories = chartofaccountData[0] && chartofaccountData[0].data
              ? [...new Set(chartofaccountData[0].data.map(x => x.category).filter(Boolean))]
              : [];
            const coaSubcategories = chartofaccountData[0] && chartofaccountData[0].data
              ? [...new Set(chartofaccountData[0].data.map(x => x.subcategory).filter(Boolean))]
              : [];
            for (let i = 0; i < dt.length; i++) {
              if (i > 0 && dt[i].length>0) {
                const el = dt[i];
                let rowdata = { "description": el[0], "category": (el[1] || '').toString().trim(), "subcategory": (el[2] || '').toString().trim()} 
                rowdata.location = (String(el[3]) || "base").split(",").filter(x => x.replaceAll(/\s/g, ''));
                rowdata.assertions = (el[4] || "").split(",").filter(x => x.replaceAll(/\s/g, ''));
                rowdata.purpose = el[5]
                rowdata.instruction = el[6] 
                rowdata.preparer = (el[7] || "").split(",").filter(x => x.replaceAll(/\s/g, ''));
                rowdata.approver = (el[8] || "").split(",").filter(x => x.replaceAll(/\s/g, ''));
                rowdata.tags = (el[9] || "").split(",").filter(x => x.replaceAll(/\s/g, ''));
                rowdata.duedays = Number(el[10] || "") || null;
                rowdata.glcode = (el[11] || "").toString().split(",").filter(x => x.replaceAll(/\s/g, ''));
                let errors = {};
                if ((rowdata.description || "").toString() === "") errors["description"] = " ";
                if ((rowdata.category || "").toString() === "") errors["category"] = " ";
                if ((rowdata.subcategory || "").toString() === "") errors["subcategory"] = " ";
                if ((rowdata.approver || "").toString() === "") errors["approver"] = " ";
                if ((rowdata.preparer || "").toString() === "") errors["preparer"] = " ";
                if(this.project) delete rowdata.tags;
                else if ((rowdata.tags || []).length === 0) errors["tags"] = " ";
                // let notfoundassertions = [];
                // for (const i of rowdata.assertions) {
                //   if(possibleassertions.indexOf(i) === -1) notfoundassertions.push(i);
                // }
                // if(notfoundassertions.length > 0) errors["assertions"] = notfoundassertions.join(", ") + " assertions not found";
                if (rowdata.preparer.length > 0 && rowdata.approver.length > 0) {
                  let preparers = rowdata.preparer;
                  let approvers = rowdata.approver;
                  let duplicates = [];
                  for (const i of preparers) {
                    if (approvers.indexOf(i.trim()) > -1) duplicates.push(i);
                  }
                  if (duplicates.length > 0) errors["preparer"] = "'" + duplicates.join(",") + "' cannot be both preparer and approver";
                }
                // if(rowdata.location.length===0) errors["location"]="Location is required"
                for(const i of rowdata.glcode){
                  if (rowdata.glcode[i] != null && rowdata.glcode[i] !== "") {
                    let isGLValid = chartofaccountData[0].data.filter(obj => obj['glcode'] == rowdata.glcode[i]) || "";
                    if (isGLValid === "" || isGLValid.length === 0) {
                      errors["glcode"] = rowdata.glcode[i] + " Invalid GL Code";
                    }
                  }
                }
                // Category & Sub Category COA validation for AC tasks (tasks with GL codes)
                if (rowdata.glcode.length > 0 && coaCategories.length > 0) {
                  if (rowdata.category && !coaCategories.includes(rowdata.category)) {
                    errors["category"] = rowdata.category + " - " + CHECKLIST_VALIDATION_MESSAGES.INVALID_CATEGORY;
                  }
                  if (rowdata.subcategory && !coaSubcategories.includes(rowdata.subcategory)) {
                    errors["subcategory"] = rowdata.subcategory + " - " + CHECKLIST_VALIDATION_MESSAGES.INVALID_SUBCATEGORY;
                  }
                }
                if (Object.keys(errors).length > 0) this.flag = true;
                filedata.push(rowdata);
                errordata.push(errors);
              }
            }
            this.uploaddata = filedata;
            this.dataerror = errordata;
            this.errorsonly = this.dataerror
            this.dialog = true;
          } else throw Error("Columns '"+headings.join("','")+"' are required in the same order");
        }).catch(err => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        }).finally(() => {
          this.file = null;
          this.fileprocessing[key] = 0;
          this.loading = false;
        });
      }
    },
    uploadData() {
      this.loading = true;
      let url = "/v2/financialclose/masters/checklist/bulkadd";
      if(this.project) url = "/v2/financialclose/analysis/bulkaddchecklist/"+this.project;
      this.axios.post(url, { data: this.uploaddata }).then(dt => {
        if (dt.data.status === "success") {
          this.dialog = false;
          this.$emit('reload');
          this.$store.commit("sbSuccess", "Checklist uploaded successfully");
        } else throw dt.data.message || "Error uploading Tasklist";
      }).catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
      }).finally(() => {
        this.loading = false;
      })
    },
    updateFilesBulk(newFilesBulk) {
      this.file = newFilesBulk[0];      
      this.readFile('file')
    },
  },
  watch: {
    showdatawitherror(newVal) {
    if (newVal) {
      this.errorsonly = this.dataerror.filter(item => Object.keys(item).length > 0);
    } else {
      this.errorsonly = this.dataerror;
    }
  }
  },
  computed:{
    filteredData() {
      if (this.showdatawitherror) {
      return this.uploaddata.filter((_, rowIndex) =>
          Object.values(this.dataerror[rowIndex]).some((error) => error)
        );
    }
    return this.uploaddata; // Return all rows if not filtering errors
      }
  }
}
</script>